var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"introduce-content"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tips"},[_vm._v(_vm._s())])])]),_c('div',{staticClass:"info main",domProps:{"innerHTML":_vm._s(_vm.detail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }